import { useEffect, useRef } from "react";

const PANEL_ENTRY_SELECTOR =
  '[role="menuitem"]:not([data-disabled]), input, button, [tabindex]';

export function useDrillFocus<T extends HTMLElement = HTMLDivElement>(
  stack: readonly string[],
  isOpen = true,
) {
  const containerRef = useRef<T>(null);
  const previousStack = useRef(stack);

  useEffect(() => {
    const previous = previousStack.current;
    previousStack.current = stack;
    const container = containerRef.current;
    if (!isOpen || !container || previous.length === stack.length) {
      return;
    }
    const leftKey =
      stack.length < previous.length ? previous[previous.length - 1] : null;
    const origin =
      leftKey === null
        ? null
        : container.querySelector<HTMLElement>(
            `[data-menu-key="${CSS.escape(leftKey)}"]`,
          );
    const target =
      origin ?? container.querySelector<HTMLElement>(PANEL_ENTRY_SELECTOR);
    target?.focus();
  }, [stack, isOpen]);

  return containerRef;
}
